export enum CurrencyType {
  MXN = 1,
  USD = 2,
}

export const currencyTypeValues: { [id: number]: string } = {
  1: 'MXN',
  2: 'USD',
};

export namespace CurrencyType {
  export function items() {
    var items = Object.keys(CurrencyType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: currencyTypeValues[+index + 1], value: +index + 1 };
      });
    return items.filter((x) => x.key != undefined);
  }
}
